module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar logo = (helpers.detectRenderedImage(model.logo, model._logo) || {}).rendered || {};\n%>\n<div class=\"<%- model.panelStyle %>\">\n<%- helpers.renderSection('backPanel'); %>\n<div class=\"left\">\n<img class=\"logo\" title=\"<%= logo.title %>\" alt=\"<%= logo.alt %>\" src=\"<%= logo.url %>\">\n</div>\n<%- helpers.renderSection('menu'); %>\n<%- helpers.renderSection('columnMenu'); %>\n<div class=\"right\">\n<%- include('./navButton'); %>\n</div>\n<%- helpers.renderSection('sidePanels'); %>\n</div>"
  , __filename = "components/templates/headPanel/headPanel.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var logo = (helpers.detectRenderedImage(model.logo, model._logo) || {}).rendered || {};

    ; __line = 3
    ; __append("\n<div class=\"")
    ; __line = 4
    ; __append( model.panelStyle )
    ; __append("\">\n")
    ; __line = 5
    ; __append( helpers.renderSection('backPanel') )
    ; __append("\n<div class=\"left\">\n<img class=\"logo\" title=\"")
    ; __line = 7
    ; __append(escapeFn( logo.title ))
    ; __append("\" alt=\"")
    ; __append(escapeFn( logo.alt ))
    ; __append("\" src=\"")
    ; __append(escapeFn( logo.url ))
    ; __append("\">\n</div>\n")
    ; __line = 9
    ; __append( helpers.renderSection('menu') )
    ; __append("\n")
    ; __line = 10
    ; __append( helpers.renderSection('columnMenu') )
    ; __append("\n<div class=\"right\">\n")
    ; __line = 12
    ; __append( include('./navButton') )
    ; __append("\n</div>\n")
    ; __line = 14
    ; __append( helpers.renderSection('sidePanels') )
    ; __append("\n</div>")
    ; __line = 15
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/headPanel/headPanel.ejs

}